import { connect } from 'react-redux';
import idx from 'idx';
import { withRouter } from 'react-router';
import { getCategory } from 'common/ducks/categories';
import { PAPFormBottomNav } from 'pap/components/common/navigation';

const mapStateToProps = ({ pap, categories }, { params }) => {
  let showGuarantee = true;
  if (params.categorySlug) {
    const category = getCategory(categories.data, params.categorySlug);
    showGuarantee = !idx(category, _ => _.is_one_to_one);
  } else {
    const project = pap.project.projectData;
    showGuarantee = !idx(project, _ => _.is_one_to_one);
  }

  return {
    showGuarantee
  };
}

export default withRouter(connect(mapStateToProps)(PAPFormBottomNav));



// WEBPACK FOOTER //
// ./pap/containers/common/bottom_nav.js